import { REWARDS_PROGRAM_NAME } from "../../reducer/selectors/textConstants";

export const HERTZ_REWARDS_WARNING = (supplierRef?: string) =>
`Adding your ${REWARDS_PROGRAM_NAME(supplierRef)} number may result in a price change if you have pre-accepted charges.`;
export const HERTZ_REWARDS_TITLE = (supplierRef?: string) =>
  `${REWARDS_PROGRAM_NAME(supplierRef)} (Optional)`;
export const HERTZ_REWARDS_SUBTITLE = (supplierRef?: string) =>
  `Enter your ${REWARDS_PROGRAM_NAME(
    supplierRef
  )} number, and ensure the name of the driver matches the name on the loyalty account. Your number will be saved to your traveler profile.`;

export const HERTZ_MODAL_PRESIDENTS_CIRCLE_INTRO = (cardName: string) =>
  `Enroll in the Hertz Gold+ Program and get President's Circle status with your ${cardName} card, to enjoy benefits like:`;

export const HERTZ_MODAL_FIVE_STAR_INTRO = (cardName: string) => 
  `Enroll in the Hertz Gold+ Program and get Five Star status with your ${cardName} card, to enjoy benefits like:`;

export const HERTZ_MODAL_PRESIDENTS_CIRCLE_BENEFITS: string[] = [
  "Skip the rental counter and go straight to your car at select locations.",
  "Get a complimentary car-class upgrade, with a maximum upgrade to a full-sized vehicle.",
  "Access to the largest selection of rental vehicles.",
  "Add your spouse or domestic partner as a driver at no extra cost.",
  "Dedicated President's Circle® call center line."
];

export const HERTZ_MODAL_FIVE_STAR_BENEFITS: string[] = [
  "Skip the rental counter and go straight to your car at select locations.",
  "Add your spouse or domestic partner as a driver at no extra cost.",
  "Get complimentary upgrades to the next car class, if available, at participating locations.",
  "Access to a wider selection of available rental vehicles." 
];

export const HERTZ_MODAL_LOGO_ALT = "Hertz Gold+";
export const HERTZ_MODAL_ENROLL_LINK = "Enroll now on Hertz's Website";
export const HERTZ_MODAL_TERMS = "Terms apply";

const HERTZ_SIGNUP_BASE_URL = "https://pub.emails.hertz.com/status-match";

const HERTZ_SIGNUP_QUERY_MAP: Record<string, string> = {
  venturex: "01012025capitaloneventurextopcv.2",
  venturexbusiness: "july2025capitalonevxfbtopc",
  venture: "01012025capitaloneventurecardtofivestarv.2",
  venturebusiness: "march2026capitaloneventurebusinesstofg",
  ventureone: "july2025capitaloneventureonetofs",
  ventureonebusiness: "march2026capitaloneventureonebusinesstofs",
  savor: "capitalonesavortofs",
  savorone: "capitalonesavortofs",
  quicksilver: "july2025capitalonequicksilvertofs",
  quicksilverone: "july2025capitalonequicksilvertofs",
  sparkmiles: "capitalonesparkmilestofs",
  // NOTE: "captial" misspelled is intentional as it is the working link
  sparkmilesselect: "captialonesparkmilesselecttofs",
};

export const getHertzSignupUrl = (caponeProduct: string): string | null => {
  const queryParam = HERTZ_SIGNUP_QUERY_MAP[caponeProduct.toLowerCase()];
  if (!queryParam) return null;
  return `${HERTZ_SIGNUP_BASE_URL}?q=${queryParam}&dialect=enUS`;
};